module.exports = __webpack_public_path__ + "img/Score-Cards_04.f12f4b92.png";